<template>
    <v-app>
        <v-app-bar app
                   color="light-blue darken-2"
                   dark
                   flat
                   absolute
        >
            <v-toolbar-title class="mr-2">{{$t('ayalonRoutes')}}</v-toolbar-title>
            <!--            <v-spacer></v-spacer>-->
        </v-app-bar>
        <v-content>
            <Container/>
                  <div class="text-center">
                      <v-overlay :value="overlay">
                        <p>{{$t('checkForNewUpdate')}}</p>
                          <v-btn color="primary" v-if="updateExists" @click="refreshApp">{{$t('updateAvailableMessage')}}</v-btn>
                      </v-overlay>
                  </div>
        </v-content>
        <v-footer app>
            <v-card-subtitle class="pa-0">Version {{appVersion}}</v-card-subtitle>
            <!-- -->
        </v-footer>
    </v-app>
</template>

<script>
    import Container from './components/Container';
    import {version} from '../package'
    import Vuex from "vuex";

    export default {
        name: 'App',
        components: {
            Container,
        },
      created() {
          let currentUrl = window.location.href;
          let surveyNumber;
          if(currentUrl && currentUrl.includes("survey")){
            let splittedCurrentUrl = currentUrl.split("/survey/")
            surveyNumber = splittedCurrentUrl[1]
            Vuex.Store.surveyFromDirectUrl = true
          }else {
            surveyNumber = this.$route.params.id;
          }
        Vuex.Store.surveyNumber = surveyNumber;
        document.addEventListener(
            'swUpdated', this.showRefreshUI, {once: true}
        );
        navigator.serviceWorker.addEventListener(
            'controllerchange', () => {
              if (this.refreshing) return;
              this.refreshing = true;
              window.location.reload();
            }
        );
      },
      data: () => ({
        //
        appVersion: version,
        refreshing: false,
        registration: null,
        updateExists: false,
        overlay: false,
      }),
      methods: {
        showRefreshUI(e) {
          this.registration = e.detail;
          if (!this.overlay) {
            this.overlay = true;
          }
          this.updateExists = true;
        },
        refreshApp() {
          this.updateExists = false;
          if (!this.registration || !this.registration.waiting) {
            this.clearCacheAndRefresh();
          } else {
            this.registration.waiting.postMessage({action: 'skipWaiting'});
          }
        },
        clearCacheAndRefresh() {
          let hostname = window.location.hostname;
          let urlPrefix = "localhost";
          if (hostname) {
            let sp = hostname.split('/.');
            urlPrefix = sp[0];
          }
          navigator.serviceWorker.getRegistrations()
              .then(function (registrations) {
                for (let registration of registrations) {
                  registration.unregister();
                }
              }).then(() => {

            caches.keys().then((keys) => {
              console.log(keys);
              return Promise.all(
                  keys.map(cacheName => {
                    // Delete the caches that are not the current one.
                    // let urlPrefix = event.data.urlPrefix;
                    if (!cacheName.includes("ayalon-pwa-c") && !cacheName.includes(urlPrefix)) {
                      return;
                    }
                    return caches.delete(cacheName)
                  })
              )
            })
          }).then(() => {
            window.location.reload();
          })
        },
      }
    };
</script>
